import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CustomOrderEntry } from '@cart/const';

@Component({
  selector: 'sd-cart-list-item-availability',
  standalone: true,
  templateUrl: './cart-list-item-availability.component.html',
  styleUrls: ['./cart-list-item-availability.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartListItemAvailabilityComponent {
  protected readonly entry = input.required<CustomOrderEntry>();

  protected readonly availability = computed(() => {
    const { product, saleUnit } = this.entry();

    const stockLevel = product?.stock?.stockLevel || '';
    const saleUnitName = saleUnit?.name;

    return saleUnitName ? `${stockLevel} ${saleUnitName}` : stockLevel;
  });
}
